import { useRef } from 'react';

import { useTranslation } from 'react-i18next';

import Card from '../../../../../components/ListWithContentLayout/components/Card/Card';

import useArrayFieldError from '../../../hooks/useArrayFieldError';
import useTabIndexes from '../../../hooks/useTabIndexes';

interface IAttachmentCardProps {
  index: number;
  hasError: boolean;
  isActive: boolean;
  onClick: (index: number) => void;
  code?: SelectBaseOption;
  date: string;
  referenceNumber?: string;
}

function AttachmentCard({ index, isActive, onClick, hasError, code, date, referenceNumber }: IAttachmentCardProps) {
  const { t } = useTranslation();
  const tabIndexes = useTabIndexes();

  const ref = useRef<HTMLDivElement>(null);

  useArrayFieldError({ tabIndex: tabIndexes.ATTACHED_DOCUMENTS, element: ref, index, setIndex: onClick });

  return (
    <Card
      title={`${index + 1}. ${code?.tag?.label || ''}`}
      onClick={() => onClick(index)}
      dataTestId="attachment-card"
      statusText={code?.value}
      isActive={isActive}
      hasError={hasError}
      ref={ref}
    >
      <div>
        <span>{t('Document Ref. No')}:</span> <span className="typography-dark">{referenceNumber || '-'}</span>
      </div>
      <div>
        <span>{t('Date')}:</span> <span className="typography-dark">{date || '-'}</span>
      </div>
    </Card>
  );
}

export default AttachmentCard;
